module.exports = __webpack_public_path__ + "static/media/egypt.e5d91542.svg";